import { render, staticRenderFns } from "./historicDetail.vue?vue&type=template&id=7325ca98&"
import script from "./historicDetail.vue?vue&type=script&lang=js&"
export * from "./historicDetail.vue?vue&type=script&lang=js&"
import style0 from "./historicDetail.vue?vue&type=style&index=0&id=7325ca98&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports